'use client';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@repo/ui';
import dynamic from 'next/dynamic';
import type { JSX } from 'react';

const DotLottieReact = dynamic(
  () => import('@lottiefiles/dotlottie-react').then((m) => m.DotLottieReact),
  { ssr: false },
);

interface IConfirmPublishDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  challengesCount: number;
  isPending?: boolean;
}

const ANIMATION_SRC =
  'https://assets-v2.lottiefiles.com/a/b2280e20-0ad2-11f0-89e8-bfd5159581b0/dEyT6BfoCt.lottie';

export function ConfirmPublishDialog({
  open,
  onOpenChange,
  onConfirm,
  challengesCount,
  isPending = false,
}: IConfirmPublishDialogProps): JSX.Element {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-md">
        <AlertDialogHeader className="flex flex-col items-center text-center">
          <div className="h-72 w-72">
            <DotLottieReact src={ANIMATION_SRC} loop autoplay className="h-full w-full" />
          </div>
          <AlertDialogTitle className="text-foreground">Publish All Challenges</AlertDialogTitle>
          <AlertDialogDescription>
            This will publish all {challengesCount} challenge{challengesCount === 1 ? '' : 's'} in
            this collection. Published challenges will be visible to users.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:justify-between">
          <AlertDialogCancel disabled={isPending} className="text-foreground">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={isPending}>
            {isPending ? 'Publishing...' : 'Publish All'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
